import "../../sass/layout/programs/programs.css";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row } from "react-bootstrap";
import chevron from "../../utils/img/chevron-right.svg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { usePath } from "../../hooks/usePath";
import { useEffect, useState } from "react";
import { ProgramCard } from "./programCard";
import { fetchProgramsDetails, fetchRetireePrograms } from "../../services/actions/programs.action";
import { Mixpanel } from "../../utils/mixpanelIntegration";
import UserService from "../../services/api/UserService";

const isRetireesPage = () => 
  window.location.pathname === "/retirees";

const Programs = ({ retireeId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loginStatus = useSelector((state) => state.userReducer.loginStatus);
  const navigate = useNavigate();
  const path = usePath();
  const [retireePrograms, setRetireePrograms] = useState([]);

  const { programs } = useSelector((state) => ({
    programs: state.programReducer.programsList,
  }));
  const location = useSelector((state) => state.homeReducer.location?.data);
  const memberID = location?.uniqueNonGuessableId;

  useEffect(() => {
    if (retireeId) {
      fetchRetireePrograms(dispatch, retireeId);
    } else {
      fetchProgramsDetails(dispatch, 'HEALTH', memberID);
    }
  }, [dispatch, location, memberID, retireeId]);

  // Update local state when programs change from Redux store
  useEffect(() => {
    if (retireeId && programs) {
      setRetireePrograms(programs);
    }
  }, [programs, retireeId]);


  const [showLeft, setShowLeft] = useState(false);

  return (
    <Container fluid className="container-programs">
      <a
        className="btn-left"
        style={{
          position: "relative",
          top: "6rem",
          right: "3.5rem",
          display: "flex",
          outline: "none",
          width: "max-content",
        }}
        onClick={() => {
          const element = document.getElementsByClassName("overflow-x");
          setShowLeft(false);
          element[0].scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            zIndex: "100",
          }}
        >
          {showLeft && (
            <img
              src={chevron}
              style={{
                transform: "rotate(180deg)",
                width: "50px",
                zIndex: "100",
              }}
              alt="arrow"
            />
          )}
        </div>
      </a>
      <a
        className="btn-right"
        style={{
          width: "50px",
          position: "absolute",
          top: "6rem",
          zIndex: "100",
          right: "-2.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={() => {
          setShowLeft(true);
          const element = document.getElementsByClassName("overflow-x");
          const sleft = element[0].scrollLeft;
          element[0].scrollTo({
            top: 0,
            left: sleft + 400,
            behavior: "smooth",
          });
        }}
      >
        <img
          src={chevron}
          style={{
            width: "50px",
            zIndex: "100",
          }}
          alt="arrow"
        />
      </a>

      <h4
        className="programs-title"
        style={
          loginStatus
            ? {
                marginTop: "2rem",
              }
            : {
                marginTop: "-3rem",
              }
        }
      >
          <div style={{ display: 'flex', width: '100%', flexDirection: 'space-between'}}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', width: '100%' }}>
          <div>
            <strong>
              {t("path.healthandwellness")} {t("path.programs")}
            </strong>
          </div>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            fontWeight: 'normal',
            marginLeft: '1rem'
          }}>
        {
                ( !isRetireesPage() &&
                  <>
                    <span style={{ color: "#0000ff", marginLeft: "0.5rem", marginRight: '0.5rem' }}>●</span>
                    <p style={{ margin: 0 }}>
                      {t("programs.blueCrossSubscribersOnly")}
                    </p>
                  </>
                )
              }
          </div>
          </div>
            <div
            onClick={() => {
              Mixpanel.track("Programs.viewAllButtonClicked", {
                locationName: location?.name,
              })
              // Navigate to retiree-specific programs list if we have a retireeId
              if (retireeId) {
                navigate(`/retirees/programslist`);
              } else {
                navigate(`/${path}/programslist`);
              }
            }}
            className="programs-description"
          >
            {t("programs.viewAll")}
          </div>
        </div>
      </h4>
      <Row className="overflow-x">
        {(retireeId ? retireePrograms : programs).map((program, index) => (
          <ProgramCard
            key={program.name || index}
            name={program.name}
            img={isRetireesPage() && program.retireeImage ? program.retireeImage : program.image}
            url={program.link}
            tooltip={program.tooltip}
            classOverride="columna-box"
            retireeId={retireeId}
          />
        ))}
      </Row>
    </Container>
  );
};

export default Programs;
